export const s2 = [
    {
        "anio" : "Datos abiertos de la Secretaría de Turismo",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/s2"
            },
           
        ]
    },{
        "anio" : "Artículo 70",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/Transparencia/xlsx/a70_f01_g_SECTURH.xlsx"
            },
            
        ]
    },
    {
        "anio" : "Código de Conducta",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/CodigoDeConducta.pdf"
            },
            
        ]
    },
    {
        "anio" : "Código de Ética",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/codigoEtica.pdf"
            },
    ]
    },
    {
        "anio" : "Acuerdo que contiene el protocolo cero para la prevención, atención y sanción del acoso sexual y/o laboral y hostigamiento sexual y/o laboral en la administración pública del Estado de Hidalgo",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/protocoloCero.pdf"
            },
    ]
    },
    {
        "anio" : "Políticas, Bases y Lineamientos para la Administración de los Recursos Humanos al servicio del Poder Ejecutivo del Estado de Hidalgo",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/lineamientosRHHidalgo.pdf"
            },
            
        ]
    },
    {
        "anio" : "Modificación al Reglamento Interior de la SECTURH",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/modifRI2025.pdf"
            },
    ]
    },
    {
        "anio" : "Manual de Partidas Centralizadas por la Oficialía Mayor 2026 ",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/centralizadas2026.pdf"
            },
    ]
    },
    {
        "anio" : "Manual de Procedimientos",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/manualProcedimientos27.pdf"
            },
    ]
    },
    {
        "anio" : "Manual de Organización",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/manualOrganizacion.pdf"
            },
    ]
    },
    {
        "anio" : "Lineamientos internos sobre Bienes Muebles Administrados por el Poder Ejecutivo del Estado de Hidalgo",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/bienes2026.pdf"
            },
    ]
    },
    {
        "anio" : "Pueblos con Sabor",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/Lineamientos_Distintivo_PCS.pdf"
            },
    ]
    },
    {
        "anio" : "Pueblos con Sabor localidades Pre Aprobadas",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/preaprobadosPCS..pdf"
            },
    ]
    },
    {
        "anio" : "Misión",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/Mision.pdf"
            },
    ]
    },
    {
        "anio" : "Visión",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/Vision.pdf"
            },
    ]
    },
    {
        "anio" : "Objetivo",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/objetivoGral.pdf"
            },
    ]
    },
    {
        "anio" : "Informe de Cumplimiento del Programa Anual de Desarrollo Archivístico 2023 (PADA)",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/informePADA2023.pdf"
            },
    ]
    },
    {
        "anio" : "Baja documental de archivo 2024",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/Transparencia/zip/bajaDocumental2024.zip"
            },
    ]
    },
    {
        "anio" : "Dictámenes Archivo SECTURH",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/Transparencia/zip/dictamenesArchivo.zip"
            },
    ]
    },
    {
        "anio" : "Programa Anual de Desarrollo Archivístico enero 2024 (PADA)",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/PADA2024.pdf"
            },
    ]
    },
    {
        "anio" : "Informe de Cumplimiento del Programa Anual de Desarrollo Archivístico 2024 (PADA)",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/informePADA2024.pdf"
            },
    ]
    },
    {
        "anio" : "Programa Anual de Desarrollo Archivístico 2025 (PADA)",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/PADA2025.pdf"
            },
    ]
    },
    {
        "anio" : "Informe de Cumplimiento del Programa Anual de Desarrollo Archivístico 2025 (PADA)",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/informepada25.pdf"
            },
    ]
    },
    {
        "anio" : "Programa Anual de Desarrollo Archivístico 2026 (PADA)",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/pada26.pdf"
            },
    ]
    },
    {
        "anio" : "Ejercicio de los Recursos 2024 (Calendarios)",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/SH-0215-2024.pdf"
            },
    ]
    },
    {
        "anio" : "Informe del cuarto trimestre del 2024 sobre el ejercicio, destino y resultados de los Recursos Federales Transferidos a las Entidades Federativas y Municipios.",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/4toInformeRecursos2024.pdf"
            },
    ]
    },
    {
        "anio" : "Informe del  segundo trimestre  del  2025  e  informe  definitivo  2024  sobre  el  ejercicio, destino y resultados de los recursos federales transferidos a las entidades federativas y municipios.",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/2informeRecursos2025.pdf"
            },
    ]
    },
    {
        "anio" : "Ejercicio de los Recursos 2025 (Calendarios)",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/recursos2025.pdf"
            },
    ]
    },
    {
        "anio" : "Ejercicio de los Recursos 2026 (Calendarios)",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/recursos2026.pdf"
            },
    ]
    },
    {
        "anio" : "Compendio Estadístico Hidalgo 2023",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/compendio2023.pdf"
            },
    ]
    },
    {
        "anio" : "Compendio Estadístico Hidalgo 2024",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/compendio2024.pdf"
            },
    ]
    },
    {
        "anio" : "Programa Sectorial de Desarrollo de Turismo Sostenible 2023-2028",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/sectorialTurismo2023.pdf"
            }
        ]
    },
    {
        "anio" : "Programa Anual de Mejora Regulatoria 2023",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/mejoraR2023.pdf"
            }
        ]
    },
    {
        "anio" : "Programa Anual de Mejora Regulatoria 2024",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/mejoraR2024.pdf"
            }
        ]
    },
    {
        "anio" : "Programa Anual de Mejora Regulatoria 2025",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/pmr2025.pdf"
            }
        ]
    },
    {
        "anio" : "Programa Anual de Mejora Regulatoria 2026",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/pmr2026.pdf"
            }
        ]
    },
    {
        "anio" : "Reglamento de Seguridad, Higiene y Medio Ambiente en el Trabajo",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/rseguridad.pdf"
            }
        ]
    },
    {
        "anio" : "Comparecencia SECTURH 2024",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/comp2024.pdf"
            }
        ]
    },
    {
        "anio" : "Manual de Normas y Lineamientos para el Ejercicio de los Recursos del Gasto de Operación e Inversión 2024",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "https://hacienda.hidalgo.gob.mx/Servicios/EjerciciodelPresupuesto2024"
            }
        ]
    },
    {
        "anio" : "Presupuesto de Egresos del Estado de Hidalgo para el Ejercicio Fiscal del Año 2024",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "http://www.congreso-hidalgo.gob.mx/biblioteca_legislativa/leyes_cintillo/Presupuesto_Egresos_2024.pdf"
            }
        ]
    },
    {
        "anio" : "Programa Anual de Adquisiciones, Arrendamientos  y Servicios 2024",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/paaas2024.pdf"
            }
        ]
    },
    {
        "anio" : "Programa Anual de Adquisiciones, Arrendamientos  y Servicios 2025",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/PAAAS 2025.pdf"
            }
        ]
    },
    {
        "anio" : "Programa Anual de Adquisiciones, Arrendamientos  y Servicios 2026",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/paaas26.pdf"
            }
        ]
    },
    {
        "anio" : "Diagnóstico de Potencialidad Turística",
        "descripcion" : "Diagnósticos por Regiones",
        "trimestres" : [
            {
                "trimestre" : "Región I Tula",
                "url" : "/pdf/r1Tula.pdf"
            },
            {
                "trimestre" : "Región II Tulancingo",
                "url" : "/pdf/r2Tulancingo.pdf"
            },
            {
                "trimestre" : "Región IV Huejutla",
                "url" : "/pdf/r4Huejutla.pdf"
            },
            {
                "trimestre" : "Región XII Jacala",
                "url" : "/pdf/r12Jacala.pdf"
            },

          ]
    },  
    {
        "anio" : "Plan Anual de Trabajo Institucional 2025",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/planInst2025.pdf"
            }
        ]
    },  
    {
        "anio" : "Plan Anual de Trabajo Institucional 2026",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/planInst2026.pdf"
            }
        ]
    },  
    {
        "anio" : "Glosario Turístico",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "/pdf/glosarioTur2026.pdf"
            }
        ]
    },  
    {
        "anio" : "Dirección General de Formación y Competitividad Turística",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "https://sites.google.com/view/dgfyct/inicio?authuser=0"
            }
        ]
    }
]